// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2n9xP","rootSmall":"AddTileButton_rootSmall__3ud15"};